import { onDocumentReady } from '../utils/events';

onDocumentReady(() => {
  $('a[href*="#"]').on('click', function (e) {
    if ($(this).is('.progress-bar__item, .services-details__anchor')) return;

    const url = $(this).attr('href');

    if (url.startsWith('http')) return;

    const currentPath = window.location.pathname;
    const linkPath = url.split('#')[0];

    if (linkPath && linkPath !== '' && linkPath !== currentPath) return;

    e.preventDefault();

    const targetId = '#' + url.split('#')[1];
    const $target = $(targetId);

    $('body').removeClass('menu-open');
    $('.menu-icon').removeClass('is-active');
    $('.top-bar').removeClass('is-active');

    setTimeout(function () {
      if ($target.length) {
        let offset = $('header').outerHeight() || 0;
        offset += window.innerWidth >= 1024 ? 60 : 0;

        $('html, body').animate(
          { scrollTop: $target.offset().top - offset },
          600
        );
      }
    }, 50);
  });

  const currentPath = window.location.pathname;

  if (currentPath === '/') {
    $(
      'li.current-menu-item a[href*="#"], li.current_page_item a[href*="#"]'
    ).each(function () {
      const url = $(this).attr('href');

      if (url.startsWith('/#')) {
        const $listItem = $(this).parent('li');

        $listItem.removeClass('current-menu-item current_page_item');

        $(this).removeAttr('aria-current');
      }
    });
  }
});
